import { Button } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Page from '../../common/Page'
import PageCard from '../../common/PageCard'
import Actions from '../../../actions'
import $t from '../../../i18n'
import NavigationCard from '../Profile/NavigationCard'
import dayjs from 'dayjs'
import Card from '../../common/Card'
import EmptyList from '../../common/EmptyList'
import Alert from '../../common/Alert'
import { event, eventTypes } from '../../../consts/eventConsts'
import { isMemberTermed } from '../../../utils/hmoUtils'
import config from '../../../config.json'

import './NHPaymentsAndBilling.css'

const NHPaymentsAndBilling = ({ onSwitchPaymentPage }) => {
  const dispatch = useDispatch()
  const {
    isPaymentsAndBillingLoading,
    billingHistory,
    paymentHistory,
    billingBalance,
    loadingInvoiceId,
    isAutoPay,
  } = useSelector(state => state.nhMember)

  const userDetails = useSelector(state => state.profile.userDetails)
  const paymentDetailsData = useSelector(
    state => state.payment.paymentDetailsData
  )

  const [shouldDisplayHistory, setShouldDisplayHistory] = useState(false)
  const [shouldDisplayInvoices, setShouldDisplayInvoices] = useState(false)
  const [isPaymentNoteVisible, setIsPaymentNoteVisible] = useState(false)
  const links = useSelector(state => state.app.links)

  const shouldShowFooterAction = !isMemberTermed(userDetails)

  // the user will be notify when the enrollment payment is available
  const isEnrollmentPaymentAvailable =
    !userDetails?.profile_metadata?.is_payment_disabled

  const futureSubscriptionBillingBalance =
    paymentDetailsData?.accountSummary?.totalBalance

  useEffect(() => {
    // ask for payments info once in session
    if (!paymentHistory || !billingHistory) {
      dispatch(
        Actions.createAction(Actions.NH_PAYMENTS_INFO_REQUESTED, {
          patientId: userDetails?.id,
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const lastBillingDate = dayjs(billingHistory?.[0]?.dueDate)
    ?.local()
    ?.format(config.genericDateFormat)

  const handleAction = item => {
    if (item?.action) {
      item.action()
    }
  }
  const paymentsCategories = [
    {
      label: $t('pages.paymentsAndBilling.history.title'),
      action: () => {
        analyticsEvent('Payment status')
        setShouldDisplayHistory(true)
      },
    },
    {
      label: $t('pages.paymentsAndBilling.invoices.title'),
      action: () => {
        analyticsEvent('Payment history')
        setShouldDisplayInvoices(true)
      },
    },
  ]

  const analyticsEvent = eventName => {
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.click,
        eventName: event.clickEvent.click,
        element: eventName,
      })
    )
  }

  const getSubtitle = () => {
    return isEnrollmentPaymentAvailable ? (
      <div>
        {$t('pages.paymentsAndBilling.subtitle')}{' '}
        <Button type="link" onClick={() => window.open(links?.FAQ || '')}>
          {$t('pages.paymentsAndBilling.readMore')}
        </Button>
      </div>
    ) : (
      $t('pages.paymentsAndBilling.noAvailableSubtitle')
    )
  }

  const handleBack = () => {
    // if one of the option true, we should back to main (make both false)
    if (shouldDisplayHistory || shouldDisplayInvoices) {
      setShouldDisplayHistory(false)
      setShouldDisplayInvoices(false)
    } else {
      // in case both of the above is false, navigate back from payments page to the previous route
      dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
    }
  }

  const onRequestInvoice = invoiceId => {
    dispatch(
      Actions.createAction(Actions.NH_PAYMENT_INVOICE_REQUESTED, {
        invoiceId,
      })
    )
  }

  const handleSSO = () => {
    dispatch(Actions.createAction(Actions.NH_PAGE_PAYMENTS_PRESSED))
  }

  const renderHome = () => {
    return (
      <>
        {paymentsCategories
          .filter(action => !action.hidden)
          .map((item, index) => (
            <div key={index}>
              <NavigationCard
                key={index}
                label={item?.label}
                className="trackable"
                handleClick={() => handleAction(item)}
              ></NavigationCard>
              <div className="divider"></div>
            </div>
          ))}
        {futureSubscriptionBillingBalance > 0 && (
          <div className="previous-subscription-indication">
            <div className="title semi-bold">
              {$t('pages.paymentsAndBilling.paymentBalance', {
                balance: futureSubscriptionBillingBalance?.toFixed(2),
              })}
            </div>
            <div className="link" onClick={onSwitchPaymentPage}>
              {$t('pages.paymentsAndBilling.goToBalancePage', { year: '2025' })}
            </div>
          </div>
        )}
      </>
    )
  }

  const renderHistory = () => {
    return (
      <Card className="payment-history-page">
        <div className="history-header">
          <div className="history-title semi-bold">
            {$t('pages.paymentsAndBilling.history.title')}
          </div>
        </div>
        {!paymentHistory?.length && (
          <EmptyList title={$t('pages.paymentsAndBilling.noInfo')} />
        )}
        {!!paymentHistory?.length && (
          <div className="history-table">
            <div className="history-table-header row">
              <div className="history-table-column">
                {' '}
                {$t('pages.paymentsAndBilling.history.date')}
              </div>
              <div className="history-table-column">
                {' '}
                {$t('pages.paymentsAndBilling.history.amount')}
              </div>
              <div className="history-table-column">
                {' '}
                {$t('pages.paymentsAndBilling.history.status')}
              </div>
            </div>
            {paymentHistory?.map((item, index) => (
              <div className="history-table-row row" key={index}>
                <div className="history-table-column">
                  {dayjs(item?.paymentDate)
                    ?.local()
                    ?.format(config.genericDateFormat)}
                </div>
                <div className="history-table-column">
                  {item?.paymentAmount}
                </div>
                <div
                  className="history-table-column status semi-bold"
                  data-status={item?.paymnetStatus}
                >
                  <span>
                    {$t(
                      'pages.paymentsAndBilling.history.' + item?.paymnetStatus,
                      {
                        defaults: [
                          {
                            message: $t(
                              'pages.paymentsAndBilling.history.Processing'
                            ),
                          },
                        ],
                      }
                    )}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    )
  }

  const renderInvoices = () => {
    return (
      <Card className="payment-history-page">
        <div className="history-header">
          <div className="history-title semi-bold">
            {$t('pages.paymentsAndBilling.invoices.title')}
          </div>
        </div>
        {!billingHistory?.length && (
          <EmptyList title={$t('pages.paymentsAndBilling.noInfo')} />
        )}
        {!!billingHistory && (
          <div className="history-table">
            {billingHistory?.map((item, index) => (
              <div className="history-table-row row" key={index}>
                <div className="history-table-column">
                  {item?.invoiceMonth?.slice(0, 3)}
                </div>
                <div className="history-table-column">${item?.totalDue}</div>
                <div className="history-table-column">
                  {dayjs(item?.dueDate)
                    ?.local()
                    ?.format(config.genericDateFormat)}
                </div>
                <div className="history-table-column">
                  <Button
                    type="link"
                    loading={loadingInvoiceId === item?.letterId}
                    onClick={() => onRequestInvoice(item?.letterId)}
                  >
                    {$t('pages.paymentsAndBilling.invoices.download')}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    )
  }

  return (
    <PageCard
      enableBack={true}
      onBack={handleBack}
      className="nh-payments-billing-page-card"
    >
      <Page
        title={$t('pages.paymentsAndBilling.title')}
        subtitle={getSubtitle()}
        className="nh-payments-billing-page-card"
        hideAlertBanner
        loading={isPaymentsAndBillingLoading}
      >
        {!isEnrollmentPaymentAvailable && (
          <img
            className="billing-error-img"
            src={config.gcpStorageUrl + '/img/billing-error.png'}
            alt=""
          />
        )}
        {isEnrollmentPaymentAvailable && (
          <>
            {' '}
            <div className="body-container">
              {shouldDisplayHistory
                ? renderHistory()
                : shouldDisplayInvoices
                ? renderInvoices()
                : renderHome()}
            </div>
            {shouldShowFooterAction && (
              <div className="page-footer">
                <div className="payment-balance-card">
                  {!isAutoPay && (
                    <div className="payment-balance-card-title">
                      {$t('pages.paymentsAndBilling.amount', {
                        date: lastBillingDate,
                      })}
                      <div className="payment-balance-card-amount">
                        ${billingBalance?.toFixed(2)}
                      </div>
                    </div>
                  )}
                  {!isAutoPay && (
                    <Button
                      type="primary"
                      className="pay-button"
                      onClick={() => setIsPaymentNoteVisible(true)}
                    >
                      {!billingBalance
                        ? $t('pages.paymentsAndBilling.managePayment')
                        : $t('pages.paymentsAndBilling.countinuePayment')}
                    </Button>
                  )}
                  {isAutoPay && (
                    <div className="row auto-pay-desc-wrapper">
                      <i className="icon-check" />
                      <div className="auto-pay-desc">
                        {' '}
                        {$t('pages.paymentsAndBilling.autoPayDesctiption', {
                          amount: billingBalance?.toFixed(2),
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {isAutoPay && shouldShowFooterAction && (
              <Button
                className="pay-button-auto-pay"
                onClick={() => setIsPaymentNoteVisible(true)}
              >
                {$t('pages.paymentsAndBilling.managePayment')}
              </Button>
            )}
          </>
        )}
      </Page>
      <Alert
        title={$t('pages.paymentsAndBilling.note.title')}
        className="payment-note"
        closable={true}
        shouldDisplay={isPaymentNoteVisible}
        onCancel={() => setIsPaymentNoteVisible(false)}
        OkText={$t('common.continue')}
        onOk={() => {
          analyticsEvent('Pay my premium now')
          setIsPaymentNoteVisible(false)
          handleSSO()
        }}
      >
        {$t('pages.paymentsAndBilling.note.note')}
        <div className="disclaimer italic">
          {$t('pages.paymentsAndBilling.note.disclaimer')}
        </div>
      </Alert>
    </PageCard>
  )
}
export default NHPaymentsAndBilling
